/** Solo rutas internas (evita open redirect). */
export function safeRedirect(target: string | undefined): '/' {
  // El tipo literal es una conveniencia de TanStack; en runtime se acepta cualquier ruta interna válida.
  if (target?.startsWith('/') && !target.startsWith('//') && !target.startsWith('/login')) {
    return target as '/';
  }
  return '/';
}

/**
 * Destino tras iniciar sesión. El platform admin va a donde pedía (o al inicio del panel); un usuario de un cliente cae en el portal
 * (o en la pantalla del portal que pedía): el panel admin no es para él (la guarda del router lo reconfirma; la API autoriza igual).
 */
export function postLoginPath(user: { isPlatformAdmin: boolean }, target: string | undefined): string {
  const safe: string = safeRedirect(target);
  if (user.isPlatformAdmin) return safe;
  // Aceptar una invitación (ADR-0016): quien inicia sesión para aceptarla vuelve a esa pantalla (no al portal).
  if (safe === '/accept-invitation') return safe;
  return safe === '/portal' || safe.startsWith('/portal/') || safe.startsWith('/portal?') ? safe : '/portal';
}
